import React from "react";

// Gráfico de rosca de progresso de hidratação (SVG puro)
const HydrationDonut = ({ pct = 0, total = 0, meta = 1600, size = 56, atingida = false }) => {
  const stroke = 6;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = Math.max(0, Math.min(pct, 1)) * c;
  const cor = atingida ? "#059669" : pct >= 0.5 ? "#0284c7" : "#f59e0b";
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid="hidratacao-donut">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e2e8f0" strokeWidth={stroke} />
        <circle
          cx={size / 2} cy={size / 2} r={r} fill="none" stroke={cor} strokeWidth={stroke}
          strokeDasharray={`${dash} ${c}`} strokeLinecap="round"
          style={{ transition: "stroke-dasharray 0.4s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center leading-none">
        <span className="text-[11px] font-bold text-slate-700">{Math.round(pct * 100)}%</span>
        <span className="text-[8px] text-slate-400">{(total / 1000).toFixed(1)}L</span>
      </div>
    </div>
  );
};

export default HydrationDonut;
